// src/components/AttendanceSundayTab.js
import React from 'react';

const AttendanceSundayTab = ({
  students,
  sundayDates,
  selectedChurchDate,
  handleChurchDateChange,
  displayedSundayDates,
  handleStudentClick,
  getAttendanceClass,
  handleEditAttendance,
  formatDisplayDate,
  dateLocks = {}, // 🌟 Nhận danh sách ngày khóa
}) => {
  return (
    <>
      <h4>Điểm danh Đi Lễ Chúa Nhật</h4>
      <table className="student-table">
        <thead>
          <tr>
            <th>Stt</th>
            <th>ID</th>
            <th>Tên Thánh</th>
            <th className="sticky-name-col">Họ và Tên</th>
            <th className="mobile-only">
              <select value={selectedChurchDate} onChange={handleChurchDateChange}>
                {sundayDates.slice().reverse().map((date, index) => (
                  <option key={index} value={date}>
                    {formatDisplayDate(date)} {dateLocks[date] ? '🔒 (Đã khóa)' : ''}
                  </option>
                ))}
              </select>
            </th>
            {displayedSundayDates.map((date, index) => (
              <th key={index} className="desktop-only">
                {formatDisplayDate(date)}
                {dateLocks[date] && (
                  <span title="Ngày đã bị khóa điểm danh bổ sung" style={{ marginLeft: 4, cursor: 'help' }}>
                    🔒
                  </span>
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {students.map((student, index) => (
            <tr key={student.id || index}>
              <td>{index + 1}</td>
              <td style={{ fontFamily: 'monospace', fontWeight: 'bold' }}>{student.id}</td>
              <td>{student.holyName || '-'}</td>
              <td className="sticky-name-col">
                <button
                  className="student-name-link"
                  onClick={() => handleStudentClick(student.id)}
                >
                  {student.fullName}
                </button>
              </td>
              <td className="mobile-only">
                <button
                  className={getAttendanceClass(student.attendance?.[selectedChurchDate]?.time).className}
                  disabled={getAttendanceClass(student.attendance?.[selectedChurchDate]?.time).isDisabled}
                  onClick={() =>
                    !getAttendanceClass(student.attendance?.[selectedChurchDate]?.time).isDisabled &&
                    handleEditAttendance(student, selectedChurchDate, 'church')
                  }
                >
                  {student.attendance?.[selectedChurchDate]?.time || 'Vắng không xin phép'}
                </button>
              </td>
              {displayedSundayDates.map((date, idx) => (
                <td key={idx} className="desktop-only">
                  <button
                    className={getAttendanceClass(student.attendance?.[date]?.time).className}
                    disabled={getAttendanceClass(student.attendance?.[date]?.time).isDisabled}
                    onClick={() =>
                      !getAttendanceClass(student.attendance?.[date]?.time).isDisabled &&
                      handleEditAttendance(student, date, 'church')
                    }
                  >
                    {student.attendance?.[date]?.time || 'Vắng không xin phép'}
                  </button>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default AttendanceSundayTab;